(function($) {

    if(Dropzone.isBrowserSupported()) {

        $.fn.fileuploader = function (options) {

            var $elem = this;
            var settings = $.extend({}, options);

            var myDropzone = new Dropzone(document.body, { // Make the whole body a dropzone
                url: "/api/uploads", // Set the url
                acceptedFiles: '.m4a,.mp3,.wav,.flac',
                createImageThumbnails: false,
                maxFilesize: 100,
                parallelUploads: 20,
                autoQueue: true,
                previewTemplate: settings.previewTemplate,
                previewsContainer: settings.previewContainer.get(0), // Define the container to display the previews
                clickable: settings.clickable.get(0) // Define the element that should be used as click trigger to select files.
            });

            myDropzone.on("sending", function (file, xhr, formData) {
                formData.append('_token', $elem.find("input[name='_token']").val());
            });

            myDropzone.on("complete", function (file) {
                console.log(file);
                switch (file.status) {
                    case 'error':
                        fileError(file.xhr, file.previewElement);
                        break;
                    case 'success':
                        fileSuccess(file.xhr.responseText, file.previewElement);
                        break;
                }
            });

            function fileSuccess(data, element) {
                $(element).remove();
                settings.addSongFunction($.parseJSON(data));
            }

            function fileError(request, element) {
                $(element).addClass('error');
                var $progress = $(element).find('.playlist-upload-progress');
                $progress.find('.progress-bar').remove();
                setTimeout(function () {
                    $(element).remove();
                }, 3000);

                switch (request.status) {
                    case 500:
                        $progress.html('A server error occured');
                        break;
                }
            }
        };

    } else {

        $.fn.fileuploader = function (options) {

            var $elem = this;
            var settings = $.extend({}, options);

            $('#upload-button').uploadify({
                'swf'      : '/assets/uploadify.swf',
                'uploader' : '/api/uploads',
                'formData' : { '_token' : $elem.find("input[name='_token']").val()},
                'fileObjName' : 'file',
                'onUploadSuccess': function(file, data, response) {
                    settings.addSongFunction($.parseJSON(data));
                }
            });
        }
    }

}( jQuery ));